import React, { lazy } from 'react';
import IconBugly from '@/assets/images/menu/icon-bugly.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const crashRoutes = (): IRouteConfig[] => [
  {
    path: '/exception/crash',
    name: '崩溃',
    icon: <MenuIcon icon={IconBugly} />,
    sort: 99,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.HarmonyOS,
      CapitalPlatform.Mac,
      CapitalPlatform.Windows,
      CapitalPlatform.VisionOS,
    ],
    routes: [
      {
        path: '/exception/crash/dashboard',
        name: '概览',
        component: lazy(() => import('@/presentation/pages/crash/dashboard')),
      },
      {
        path: '/exception/crash/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/crash/issues/list')),
      },
      {
        path: '/exception/crash/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/crash/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/crash/caller/detail',
        name: '调用方详情',
        component: lazy(() => import('@/presentation/pages/crash/caller-detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/exception/crash/application-exit-info',
        name: '进程退出分析',
        component: lazy(() => import('@/presentation/pages/crash/application-exit-info')),
        platforms: [CapitalPlatform.Android],
      },
      {
        path: '/exception/crash/abnormal-exit-info',
        name: '异常退出分析',
        component: lazy(() => import('@/presentation/pages/crash/abnormal-exit-info')),
        platforms: [CapitalPlatform.IOS, CapitalPlatform.VisionOS, CapitalPlatform.Mac],
      },
    ],
  },
];

export default crashRoutes;
